import React, { ReactNode } from "react";
import { createClasses } from "@bloomberg/media-ui-core";

import styles from "./styles.module.css";

/**
 * Layout variants for a ZoneContainer
 */
export type ZoneContainerVariant = "full" | "lefty" | "righty";

export interface ZoneContainerProps {
  zoneId?: string;
  variant: ZoneContainerVariant;
  className?: string;
  children: ReactNode;
}

/**
 * ZoneContainer is the parent wrapper that defines a layout zone.
 * It renders a semantic <section> with data attributes for easy querying or styling.
 */
export const ZoneContainer: React.FC<ZoneContainerProps> = ({
  zoneId = "zone_container",
  variant,
  className,
  children,
}) => {
  const cx = createClasses([styles.zone, className]);

  return (
    <section
      data-zone-id={zoneId}
      data-zone-variant={variant}
      data-component="zone"
      className={cx}
    >
      {children}
    </section>
  );
};
